import React, { Component } from "react";

import {
  CButton,
  CInput,
  CLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Card,
  CardBody,
  Col,
  Row
} from "reactstrap";
import { bindActionCreators } from "redux";

import { setObj } from "../../actions/noteActions";
import { profileUpdate, profileGet } from "../../actions/profileActions";
import profileEmpty from "../../assets/imgs/profileEmpty.jpg";
import Breadcrumb from "../../components/Breadcrumb";
import Avatar from "../../components/Forms/avatar";
import Loading from "../../components/Loading";
import ProtectedRoute from "../../components/ProtectedRoute";
import URL from "../../config/api";
import axios from "../../config/axios";

import "./styles.css";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      send: true,
      nameEdit: false,
      surnameEdit: false,
      emailEdit: false,
      phoneEdit: false,
      birthdayEdit: false,
      genderEdit: false,
      cityEdit: false,
      countryEdit: false,
      passwordEdit: false,
      // search: false,
      password: "",
      confirmPassword: "",
      // savePassword: false,
      user: {},
      loading: true,
      // edit: true,
      parentModal: false,
      newParentId: "",
      parentLoading: false,
      parents: []
    };

    this.nameToggle = this.nameToggle.bind(this);
    this.nameHandler = this.nameHandler.bind(this);

    this.surnameToggle = this.surnameToggle.bind(this);
    this.surnameHandler = this.surnameHandler.bind(this);

    this.emailToggle = this.emailToggle.bind(this);
    this.emailHandler = this.emailHandler.bind(this);

    this.phoneToggle = this.phoneToggle.bind(this);
    this.phoneHandler = this.phoneHandler.bind(this);

    this.birthdayToggle = this.birthdayToggle.bind(this);
    this.birthdayHandler = this.birthdayHandler.bind(this);

    this.genderToggle = this.genderToggle.bind(this);
    this.genderHandler = this.genderHandler.bind(this);

    this.cityToggle = this.cityToggle.bind(this);
    this.cityHandler = this.cityHandler.bind(this);

    this.countryToggle = this.countryToggle.bind(this);
    this.countryHandler = this.countryHandler.bind(this);
  }

  onUnload = e => {
    // the method that will be used for both add and remove event
    e.preventDefault();
    e.returnValue = "";
  };

  componentDidMount() {
    const get = this.props.match.params.id;
    this.props.setObj(20, get, this.props.currentRoute);

    this.props.profileGet(get, this.props.user.token, user => {
      this.setState(() => ({
        user: user.user,
        user_complement: user.user_complement,
        parents: user.user_parent.map(user => user.parent),
        // search: false,
        loading: false
      }));
    });

    window.addEventListener("beforeunload", this.onUnload);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onUnload);
  }

  nameHandler(e) {
    const nameN = e.target.value;
    this.setState(prevState => ({
      user: { ...prevState.user, name: nameN }
    }));
  }

  surnameHandler(e) {
    const surnameN = e.target.value;
    this.setState(prevState => ({
      user: { ...prevState.user, surname: surnameN }
    }));
  }

  emailHandler(e) {
    const emailN = e.target.value;
    this.setState(prevState => ({
      user: { ...prevState.user, email: emailN }
    }));
  }

  phoneHandler(e) {
    const phoneN = e.target.value;
    this.setState(prevState => ({
      user: { ...prevState.user, phone: phoneN }
    }));
  }

  birthdayHandler(e) {
    const birthdayN = e.target.value;
    this.setState(prevState => ({
      user_complement: { ...prevState.user_complement, birthday: birthdayN }
    }));
  }

  genderHandler(e) {
    const genderN = e.target.value;
    this.setState(prevState => ({
      user_complement: { ...prevState.user_complement, gender: genderN }
    }));
  }

  cityHandler(e) {
    const cityN = e.target.value;
    this.setState(prevState => ({
      user_complement: { ...prevState.user_complement, city: cityN }
    }));
  }

  countryHandler(e) {
    const countryN = e.target.value;
    this.setState(prevState => ({
      user_complement: { ...prevState.user_complement, country: countryN }
    }));
  }

  nameToggle() {
    if (this.state.nameEdit) {
      this.setState(() => ({ nameEdit: false }));
      this.forceUpdate();
    } else {
      this.setState(() => ({ send: true }));
      this.setState(() => ({ nameEdit: true }));
      this.forceUpdate();
    }
  }

  surnameToggle() {
    if (this.state.surnameEdit) {
      this.setState(() => ({ surnameEdit: false }));
      this.forceUpdate();
    } else {
      this.setState(() => ({ send: true }));
      this.setState(() => ({ surnameEdit: true }));
      this.forceUpdate();
    }
  }

  emailToggle() {
    if (this.state.emailEdit) {
      this.setState(() => ({ emailEdit: false }));
    } else {
      this.setState(() => ({ send: true }));
      this.setState(() => ({ emailEdit: true }));
    }
    this.forceUpdate();
  }

  phoneToggle() {
    if (this.state.phoneEdit) {
      this.setState(() => ({ phoneEdit: false }));
    } else {
      this.setState(() => ({ send: true }));
      this.setState(() => ({ phoneEdit: true }));
    }
    this.forceUpdate();
  }

  birthdayToggle() {
    if (this.state.birthdayEdit) {
      this.setState(() => ({ birthdayEdit: false }));
    } else {
      this.setState(() => ({ send: true }));
      this.setState(() => ({ birthdayEdit: true }));
    }
    this.forceUpdate();
  }

  genderToggle() {
    if (this.state.genderEdit) {
      this.setState(() => ({ genderEdit: false }));
    } else {
      this.setState(() => ({ send: true }));
      this.setState(() => ({ genderEdit: true }));
    }
    this.forceUpdate();
  }

  cityToggle() {
    if (this.state.cityEdit) {
      this.setState(() => ({ cityEdit: false }));
    } else {
      this.setState(() => ({ send: true }));
      this.setState(() => ({ cityEdit: true }));
    }
    this.forceUpdate();
  }

  countryToggle() {
    if (this.state.countryEdit) {
      this.setState(() => ({ countryEdit: false }));
    } else {
      this.setState(() => ({ send: true }));
      this.setState(() => ({ countryEdit: true }));
    }
    this.forceUpdate();
  }

  passwordToggle() {
    if (this.state.passwordEdit) {
      this.setState(() => ({ passwordEdit: false }));
    } else {
      this.setState(() => ({ send: true }));
      this.setState(() => ({ passwordEdit: true }));
    }
    this.forceUpdate();
  }

  passwordEdit() {
    if (this.state.password.length < 8) {
      toastr.error(
        "A senha precisa de pelo menos 8 caracteres",
        "Digite novamente"
      );
      return;
    }

    if (this.state.password === this.state.confirmPassword) {
      this.updateProfile();
      this.passwordToggle();
    } else {
      toastr.error("As senhas não são iguais", "Digite novamente");
    }
  }

  addParent() {
    if (!this.state.newParentId) {
      toastr.warning("Atenção", "Digite um código");

      return;
    }

    this.setState({ parentLoading: true });

    axios
      .get(`${URL.api}access/user/singleView/${this.state.newParentId}`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            if (resp.data.data.user_role.find(e => e.role_id === 8)) {
              this.setState(state => ({
                parentLoading: false,
                parents: [...state.parents, resp.data.data.user],
                newParentId: "",
                parentModal: false
              }));
            } else {
              toastr.warning("Atenção", "Esse usuário não é um responsável");
              this.setState({ parentLoading: false });
            }
          } else {
            toastr.error("Erro", "Falha ao adicionar responsável");
            this.setState({ parentLoading: false });
          }
        },
        () => {
          toastr.error("Erro", "Falha ao adicionar responsável");
          this.setState({ parentLoading: false });
        }
      );
  }

  removeParent(id) {
    this.setState(state => ({
      parents: state.parents.filter(e => e.id !== id)
    }));
  }

  capture = value => {
    this.setState(prevState => ({
      user: { ...prevState.user, photo: value }
    }));
  };

  updateProfile() {
    let { user } = this.state;
    user = { ...user, password: this.state.password };

    this.props.profileUpdate(
      user,
      this.state.user_complement,
      () => {
        toastr.success("Sucesso", "Perfil editado com sucesso!");
      },
      this.state.parents.map(parent => parent.id)
    );
  }

  render() {
    if (!this.state.user) return null;

    const canEdit =
      parseInt(this.props.match.params.id) === this.props.user.user.id;

    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        <CModal
          show={this.state.passwordEdit}
          onClose={() => this.passwordToggle()}
          centered
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>Editar senha</CModalHeader>
          <CModalBody>
            <CInput
              type="password"
              placeholder="Digite sua nova senha"
              className="mb-3"
              value={this.state.password}
              onChange={e => this.setState({ password: e.target.value })}
            />
            <CInput
              type="password"
              placeholder="Digite sua nova senha novamente"
              value={this.state.confirmPassword}
              onChange={e => this.setState({ confirmPassword: e.target.value })}
            />
          </CModalBody>
          <CModalFooter>
            <CButton
              color="primary"
              onClick={() => (
                // eslint-disable-next-line react/no-unused-state
                this.passwordEdit(), this.setState({ savePassword: true })
              )}
            >
              Salvar
            </CButton>
            <CButton
              color="secondary"
              onClick={() => {
                // eslint-disable-next-line react/no-unused-state
                this.setState({ savePassword: false });
                this.passwordToggle();
              }}
            >
              Cancelar
            </CButton>
          </CModalFooter>
        </CModal>
        <CModal
          show={this.state.parentModal}
          onClose={() => this.setState({ parentModal: false, newParentId: "" })}
          centered
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>Adicionar responsável</CModalHeader>
          <CModalBody>
            <div className="font-weight-bold mb-2">Código do responsável</div>
            <CInput
              placeholder="Digite o código do responsável"
              value={this.state.newParentId}
              onChange={e => this.setState({ newParentId: e.target.value })}
            />
          </CModalBody>
          <CModalFooter className="pt-0 border-0">
            <CButton
              color="primary"
              disabled={this.state.parentLoading ? "disabled" : undefined}
              onClick={() => this.addParent()}
            >
              {this.state.parentLoading ? "Adicionando" : "Adicionar"}
            </CButton>
          </CModalFooter>
        </CModal>
        <div id="profile" className="animated fadeIn">
          <Card>
            <CardBody>
              {this.state.loading ? (
                <Loading color="123abc" loading top="4" left="16" />
              ) : (
                <React.Fragment>
                  {canEdit ? (
                    this.state.user.photo !== undefined ||
                    this.state.user.photo !== "" ||
                    this.state.user.photo ? (
                      <Avatar
                        capture={this.capture}
                        user={this.state.user}
                        photo={this.state.user.photo}
                      />
                    ) : (
                      ""
                    )
                  ) : (
                    <div id="avatarArea">
                      <img
                        className="imgAvatar avatarPos"
                        src={
                          this.state.user.photo
                            ? URL.img + this.state.user.photo
                            : profileEmpty
                        }
                        alt="profile"
                      />
                      <div className="fileArea" />
                    </div>
                  )}
                  <div className="userBasics mb-4">
                    <h4>{this.state.user.name}</h4>
                    <small>{this.state.user.email}</small>
                  </div>
                  {canEdit && this.props.general.active_roles.type === "S" && (
                    <div
                      className="d-flex w-100 align-items-center justify-content-center p-4 bg-light rounded mb-4"
                      style={{
                        borderWidth: "2px",
                        borderStyle: "dashed",
                        borderColor: "var(--secondary)",
                        fontSize: "1.5rem"
                      }}
                    >
                      Meu código de responsável é:&nbsp;
                      <b>{this.props.user.user.id}</b>
                    </div>
                  )}
                  {canEdit && this.props.general.active_roles.type === "A" && (
                    <div
                      className="w-100 p-3 rounded mb-4"
                      style={{
                        borderWidth: "2px",
                        borderStyle: "dashed",
                        borderColor: "var(--secondary)"
                      }}
                    >
                      <FormGroup className="m-0">
                        <CLabel className="font-weight-bold d-block">
                          Meus responsáveis
                        </CLabel>
                        {this.state.parents.map(parent => (
                          <div
                            key={parent.id}
                            className="d-flex align-items-center justify-content-between mb-2"
                          >
                            <span>{parent.name}</span>
                            <CButton
                              color="danger"
                              size="sm"
                              onClick={() => this.removeParent(parent.id)}
                            >
                              Remover
                            </CButton>
                          </div>
                        ))}
                        <CButton
                          variant="outline"
                          color="light"
                          className="text-dark"
                          onClick={() => this.setState({ parentModal: true })}
                        >
                          Adicionar
                        </CButton>
                      </FormGroup>
                    </div>
                  )}
                  <div className="profileFields">
                    <FormGroup>
                      <CLabel className="font-weight-bold">Nome</CLabel>
                      {canEdit ? (
                        <InputGroup>
                          {this.state.nameEdit ? (
                            <Input
                              type="text"
                              id="name"
                              name="name"
                              defaultValue={this.state.user.name}
                              onChange={this.nameHandler}
                            />
                          ) : (
                            <p className="form-control">
                              {this.state.user.name}
                            </p>
                          )}
                          <InputGroupAddon
                            addonType="append"
                            className={this.state.nameEdit ? "fixed" : ""}
                          >
                            <InputGroupText onClick={this.nameToggle}>
                              <i
                                className={
                                  this.state.nameEdit
                                    ? "fa fa-check"
                                    : "fa fa-pencil"
                                }
                              ></i>
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      ) : (
                        <p>{this.state.user.name}</p>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <CLabel className="font-weight-bold">E-mail</CLabel>
                      {canEdit ? (
                        <InputGroup>
                          {this.state.emailEdit ? (
                            <Input
                              type="text"
                              id="email"
                              name="email"
                              defaultValue={this.state.user.email}
                              onChange={this.emailHandler}
                            />
                          ) : (
                            <p className="form-control">
                              {this.state.user.email}
                            </p>
                          )}
                          <InputGroupAddon
                            addonType="append"
                            className={this.state.emailEdit ? "fixed" : ""}
                          >
                            <InputGroupText onClick={this.emailToggle}>
                              <i
                                className={
                                  this.state.emailEdit
                                    ? "fa fa-check"
                                    : "fa fa-pencil"
                                }
                              ></i>
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      ) : (
                        <p>{this.state.user.email}</p>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <CLabel className="font-weight-bold">Telefone</CLabel>
                      {canEdit ? (
                        <InputGroup>
                          {this.state.phoneEdit ? (
                            <Input
                              type="text"
                              id="phone"
                              name="phone"
                              defaultValue={this.state.user.phone}
                              onChange={this.phoneHandler}
                            />
                          ) : (
                            <p className="form-control">
                              {this.state.user.phone}
                            </p>
                          )}
                          <InputGroupAddon
                            addonType="append"
                            className={this.state.phoneEdit ? "fixed" : ""}
                          >
                            <InputGroupText onClick={this.phoneToggle}>
                              <i
                                className={
                                  this.state.phoneEdit
                                    ? "fa fa-check"
                                    : "fa fa-pencil"
                                }
                              ></i>
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      ) : (
                        <p>{this.state.user.phone}</p>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <CLabel className="font-weight-bold">
                        Data de nascimento
                      </CLabel>
                      {canEdit ? (
                        <InputGroup>
                          {this.state.birthdayEdit ? (
                            <Input
                              type="date"
                              id="birthday"
                              name="birthday"
                              defaultValue={
                                this.state.user_complement?.birthday
                              }
                              onChange={this.birthdayHandler}
                            />
                          ) : (
                            <p className="form-control">
                              {this.state.user_complement?.birthday}
                            </p>
                          )}
                          <InputGroupAddon
                            addonType="append"
                            className={this.state.birthdayEdit ? "fixed" : ""}
                          >
                            <InputGroupText onClick={this.birthdayToggle}>
                              <i
                                className={
                                  this.state.birthdayEdit
                                    ? "fa fa-check"
                                    : "fa fa-pencil"
                                }
                              ></i>
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      ) : (
                        <p>{this.state.user_complement?.birthday}</p>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <CLabel className="font-weight-bold">Gênero</CLabel>
                      {canEdit ? (
                        <InputGroup>
                          {this.state.genderEdit ? (
                            <Input
                              type="select"
                              id="gender"
                              name="gender"
                              defaultValue={this.state.user_complement?.gender}
                              onChange={this.genderHandler}
                            >
                              <option value="Masculino">Masculino</option>
                              <option value="Feminino">Feminino</option>
                            </Input>
                          ) : (
                            <p className="form-control">
                              {this.state.user_complement?.gender}
                            </p>
                          )}
                          <InputGroupAddon
                            addonType="append"
                            className={this.state.genderEdit ? "fixed" : ""}
                          >
                            <InputGroupText onClick={this.genderToggle}>
                              <i
                                className={
                                  this.state.genderEdit
                                    ? "fa fa-check"
                                    : "fa fa-pencil"
                                }
                              ></i>
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      ) : (
                        <p>{this.state.user_complement?.gender}</p>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <CLabel className="font-weight-bold">Cidade</CLabel>
                      {canEdit ? (
                        <InputGroup>
                          {this.state.cityEdit ? (
                            <Input
                              type="text"
                              id="city"
                              name="city"
                              defaultValue={this.state.user_complement?.city}
                              onChange={this.cityHandler}
                            />
                          ) : (
                            <p className="form-control">
                              {this.state.user_complement?.city}
                            </p>
                          )}
                          <InputGroupAddon
                            addonType="append"
                            className={this.state.cityEdit ? "fixed" : ""}
                          >
                            <InputGroupText onClick={this.cityToggle}>
                              <i
                                className={
                                  this.state.cityEdit
                                    ? "fa fa-check"
                                    : "fa fa-pencil"
                                }
                              ></i>
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      ) : (
                        <p>{this.state.user_complement?.city}</p>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <CLabel className="font-weight-bold">País</CLabel>
                      {canEdit ? (
                        <InputGroup>
                          {this.state.countryEdit ? (
                            <Input
                              type="text"
                              id="country"
                              name="country"
                              defaultValue={this.state.user_complement?.country}
                              onChange={this.countryHandler}
                            />
                          ) : (
                            <p className="form-control">
                              {this.state.user_complement?.country}
                            </p>
                          )}
                          <InputGroupAddon
                            addonType="append"
                            className={this.state.countryEdit ? "fixed" : ""}
                          >
                            <InputGroupText onClick={this.countryToggle}>
                              <i
                                className={
                                  this.state.countryEdit
                                    ? "fa fa-check"
                                    : "fa fa-pencil"
                                }
                              ></i>
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      ) : (
                        <p>{this.state.user_complement?.country}</p>
                      )}
                    </FormGroup>
                  </div>
                  {canEdit ? ( // Trecho do botão de editar senha removido momentaneamente pela Construir
                    <Row>
                      <Col xs="6"></Col>
                      <Col xs="6" className="text-right">
                        <CButton
                          color="primary"
                          onClick={() => this.updateProfile()}
                          disabled={!this.state.send}
                        >
                          Salvar
                        </CButton>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              )}
            </CardBody>
          </Card>
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      profileUpdate,
      profileGet,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
